import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from './context/ThemeContext';
import theme from './theme';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import CollectionPage from './pages/CollectionPage';
import ItemPage from './pages/ItemPage';

const globalStyles = {
  '*': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
  html: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    height: '100%',
    width: '100%',
  },
  body: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.background.default,
  },
  '#root': {
    height: '100%',
    width: '100%',
  },
  '::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '::-webkit-scrollbar-track': {
    background: theme.palette.background.default,
  },
  '::-webkit-scrollbar-thumb': {
    background: theme.palette.background.card,
    borderRadius: '4px',
  },
  '::-webkit-scrollbar-thumb:hover': {
    background: theme.palette.background.paper,
  },
  a: {
    textDecoration: 'none',
    color: 'inherit',
  },
};

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <div style={{ 
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
        }}>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/collection/:collectionId" element={<CollectionPage />} />
            <Route path="/collection/:collectionId/item/:itemId" element={<ItemPage />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
